import { render, staticRenderFns } from "./PaymentQuotaDetail.vue?vue&type=template&id=527d6aef&"
import script from "./PaymentQuotaDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentQuotaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports